import { Id, UuidIdGenerator } from '@prodcard/core'
import { useWatcherSavedRef } from './useHistorySavedRef'
import { Router } from 'vue-router'

const state: Record<string, unknown> = {}

export async function callPage(key: string, route: string, router?: Router) {
  const uid = useWatcherSavedRef<Id>(key, undefined)
  uid.value = new UuidIdGenerator().generate()

  await router?.push({ path: route, query: { resultId: uid.value } })
}

export function usePageResult<T>(key: string): T {
  const uid = useWatcherSavedRef<Id>(key)
  return state[uid.value] as T
}

export function publishResult<T>(uid: Id, result: T) {
  state[uid] = result
}
